import * as axios from 'axios';

const { VUE_APP_API_URL } = process.env || {};

export const getDoors = (token) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/doors`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
